import * as R from 'ramda'

export default R.pipe(R.toLower, R.trim)
